export const ACTIONS = {
  SET_SALES_ORDER_NUMBERS: 'PICK_TICKET__SET_SALES_ORDER_NUMBERS',
  SET_SHOW_POPUP: 'PICK_TICKET__SET_SHOW_POPUP',
  SET_SHOW_PICK_TICKET_GENERATOR_MODAL: 'PICK_TICKET__SET_SHOW_PICK_TICKET_GENERATOR_MODAL',
  GENERATE_TICKETS: 'PICK_TICKET_GENERATOR__GENERATE_TICKETS',
  GENERATE_TICKETS_SUCCESS: 'PICK_TICKET_GENERATOR__GENERATE_TICKETS_SUCCESS',
  GENERATE_TICKETS_ERROR: 'PICK_TICKET_GENERATOR__GENERATE_TICKETS_ERROR',
  RESET_STATE: 'PICK_TICKET_GENERATOR__RESET_STATE',
};